// extracted by mini-css-extract-plugin
export var active = "layout-module--active--EBglz";
export var bgvid = "layout-module--bgvid--HH2zB";
export var btn = "layout-module--btn--89NIY";
export var container = "layout-module--container--RoCXy";
export var content = "layout-module--content--FwTjf";
export var erreur = "layout-module--erreur--MFvG2";
export var m_button = "layout-module--m_button--SlId7";